export const Assets: any = {
    BG1: { ID:'background_1', FILENAME:'bgimg1.png' },
    BG2: { ID:'background_2', FILENAME:'bgimg2.png' },
    BG3: { ID:'background_3', FILENAME:'bgimg3.png' },
    BG4: { ID:'background_4', FILENAME:'bgimg4.png' },
    BG5: { ID:'background_5', FILENAME:'bgimg5.png' },
    GAME: { ID:'game', FILENAME:'game.png', JSON:'game.json' },
    FONT1: { ID:'font1', FILENAME:'pressstart2p.png', XML:'pressstart2p.xml' },
    BGMUSIC: { ID: 'bgmusic', FILENAME: 'bgmusic.mp3' },
    SHOOTSFX: { ID: 'shoot', FILENAME: 'shoot.mp3' },
    LOSTSFX: { ID: 'lost', FILENAME: 'lost.mp3' },
}